/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AutoCheckoutService } from 'src/app/services/auto-checkout/auto-checkout.service';
import { PageStateService } from 'src/app/services/page-state.service';
import { CountryCodeModalComponent } from '../modals/country-code-modal/country-code-modal.component';
import { CountryCode } from 'src/app/models/country-code';
import { SelectListModalComponent } from '../modals/select-list-modal/select-list-modal.component';
import { SmartDatePipe } from 'src/app/pipes/smart-date.pipe';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';
import { UserGuestListComponent } from '../user-guest-list/user-guest-list.component';
import { AccountService } from 'src/app/services/user/account.service';
import countryMeta from 'src/app/data/country-meta';
import { GenericModalComponent } from '../modals/generic-modal/generic-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/app/services/client/theme/theme.service';

@Component({
  selector: 'app-autocheckout-form',
  templateUrl: './autocheckout-form.component.html',
  styleUrls: ['./autocheckout-form.component.scss'],
})
export class AutocheckoutFormComponent implements OnInit {
  @Input() storeId: string;
  public form_data: any[];
  public validBdate: any;
  public formFields: any[];
  public formQuestionData = true;
  public minPickupDate: any;
  public minPickupDateTime: any;
  public incomingSeconds: any;
  public form = new UntypedFormGroup({});
  private userGuestList: any;
  private questionSet: any;
  public selectedCountryCode: CountryCode;
  public userInfo: any;
  public saveGuest: boolean = false;
  public currentHeaderData: any = {
    modal: true,
    backIcon: true,
    marl0: true,
    title: 'autocheckout_form.header',
  };
  public isGuestListModalOpen: boolean = false;
  public isFormReady: boolean = false;
  public isSubmitting: boolean = false;

  constructor(
    private autoCheckoutService: AutoCheckoutService,
    private modalController: ModalController,
    private pageStateService: PageStateService,
    private smartDatePipe: SmartDatePipe,
    private analyticsService: AnalyticsService,
    private dynamicFormService: DynamicFormService,
    private accountService: AccountService,
    private theme: ThemeService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.selectedCountryCode = this.theme.getDefaultCountry;
    this.form_data = [];
    this.questionSet = [];
    const currentBdate = new Date();
    this.minPickupDateTime = new Date();
    this.minPickupDate = this.smartDatePipe.transform(
      this.minPickupDateTime,
      'yyyy-MM-dd'
    );
    this.incomingSeconds = 0;
    const numberOfYearToSubstract = 18;
    this.validBdate = this.smartDatePipe.transform(
      currentBdate.setFullYear(
        currentBdate.getFullYear() - numberOfYearToSubstract
      ),
      'yyyy-MM-dd',
      'en-US'
    );
    this.userInfo = this.dynamicFormService.getUserInfo;
    this.updatePageState();
  }

  closeModal() {
    // this.airportListService.setSelectedAirport(selectedAirport.airportCode);
    this.modalController.dismiss();
  }

  updatePageState() {
    this.isFormReady = false;
    this.autoCheckoutService
      .getAutoCheckoutForm(this.storeId)
      .subscribe((response) => {
        if (response?.pickup_start_time !== null && response?.pickup_start_time !== undefined) {
          const seconds = Number(response.pickup_start_time) || 0;
          this.incomingSeconds = seconds;
          const currentDate = new Date();
          this.minPickupDateTime = new Date(
            currentDate.getTime() + seconds * 1000
          );
          this.minPickupDate = this.smartDatePipe.transform(
            this.minPickupDateTime,
            'yyyy-MM-dd'
          );
        }
        if (response.questions && response.questions.length > 0) {
          this.form_data = response.questions;

          for (const formField of this.form_data) {
            this.form.addControl(formField.name, this.getValidator(formField));
            const fieldValue = this.getFieldValue(formField);
            if (fieldValue !== undefined) {
              this.form.get(formField.name).setValue(fieldValue);
            }
            this.questionSet[formField.name] = [];
            this.questionSet[formField.name].label = formField.question;
            this.questionSet[formField.name].id = formField.id;
          }
          this.formFields = this.form_data;
          this.isFormReady = true;
        } else {
          this.formQuestionData = false;
          this.isFormReady = false;
        }
      }, () => {
        this.isFormReady = false;
      });
  }
  private getFieldValue(formField: any) {
    switch (formField.name) {
      case 'name':
        return this.userInfo.name;
      case 'first_name':
        return (
          this.userInfo.name &&
          this.separateNameParts(this.userInfo.name).firstName
        );
      case 'last_name':
        return (
          (this.userInfo.name &&
            this.separateNameParts(this.userInfo.name).lastName) ||
          ''
        );
      case 'last':
        return (
          (this.userInfo.name &&
            this.separateNameParts(this.userInfo.name).lastName) ||
          ''
        );
      case 'email':
        return this.userInfo.email;
      case 'mobile_number':
        return this.userInfo.phoneNo;
      case 'phone_number':
        return this.userInfo.phoneNo;
      case 'calling_code':
        return (
          this.selectedCountryCode?.flag + this.selectedCountryCode.dialCode
        );
      default:
        return undefined;
    }
  }

  separateNameParts(fullName) {
    const nameParts = fullName.split(' ');
    const lastName = nameParts.pop();
    const firstName = nameParts.join(' ');

    return {
      lastName,
      firstName,
    };
  }

  async submitRequest() {
    if (this.isSubmitting || !this.isFormReady || !this.formFields?.length) {
      return;
    }
    this.isSubmitting = true;
    try {
      let submitted = false;
      if (this.theme.getClientName === 'thomascook_fc') {
        submitted = await this.thomasCookCardModal();
      } else {
        submitted = this.submitData();
      }
      if (!submitted) {
        this.isSubmitting = false;
      }
    } catch {
      this.isSubmitting = false;
    }
  }

  submitData(): boolean {
    if (!this.isFormReady || !this.formFields?.length) {
      return false;
    }
    this.analyticsService.trackCheckoutFormSubmission(this.form.value);
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      control.markAsTouched({ onlySelf: true });
      control.updateValueAndValidity();
    });
    if (this.form.invalid) {
      return false;
    }
    const requestData = [];
    Object.keys(this.form.value).forEach((key) => {
      requestData.push({
        answer:
          this.questionSet[key].id !== 36
            ? this.form.value[key]
            : this.selectedCountryCode.dialCode,
        question: this.questionSet[key].label,
        questionId: this.questionSet[key].id,
      });
    });

    if (this.saveGuest) {
      this.accountService
        .addUserGuest(requestData, 'dutyfree')
        .subscribe((response) => {});
    }

    this.pageStateService.setReloadAll();

    this.modalController.dismiss({
      formInfo: requestData,
    });
    this.analyticsService.trackUnified('request_initiated', {
      flow: 'airport_dutyfree',
      outcome: 'success',
      legacy_event_name: 'form_submitted',
      component: 'autocheckout-form-component',
      button: 'place-order-button',
      service: 'dutyfree',
    });
    return true;
  }

  public async thomasCookCardModal(): Promise<boolean> {
    const modal = await this.modalController.create({
      component: GenericModalComponent,
      componentProps: {
        icon: 'TX_CARD_ICON',
        heading: '',
        message: this.translate.instant('modals.generic_alert.please_use_thomas_cook_forex_card_to_avail_the_offers'),
        returnOkay: true
      },
      cssClass: 'generic-modal',
    });
    await modal.present();
    const data = await modal.onDidDismiss();
    if (data?.data) {
      return this.submitData();
    }
    return false;
  }

  isCallingCode() {
    return this.formFields.some((field) => field.name === 'calling_code');
  }

  private getValidator(formField: any): any {
    switch (formField.name) {
      case 'email':
        return new UntypedFormControl('', [
          Validators.required,
          Validators.email,
        ]);
      case 'phone_number':
        return new UntypedFormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
        ]);
      case 'passport_expiry':
        return new UntypedFormControl('', [
          Validators.required,
          this.dateRangeValidator(new Date(this.minPickupDate)),
        ]);
      case 'pickup_date':
        return new UntypedFormControl('', [
          Validators.required,
          this.dateRangeValidator(new Date(this.minPickupDate)),
        ]);
      case 'date_of_birth':
        return new UntypedFormControl('', [
          Validators.required,
          this.dateRangeValidator(undefined, new Date(this.validBdate)),
        ]);
      case 'pickup_time':
        return new UntypedFormControl('', [
          Validators.required,
          this.timeValidator(),
        ]);
      default:
        return new UntypedFormControl('', [Validators.required]);
    }
  }

  dateRangeValidator(minDate?: Date, maxDate?: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const inputDate = new Date(control.value);
      if (minDate && inputDate < minDate) {
        return { minDate: { value: control.value } };
      }
      if (maxDate && inputDate > maxDate) {
        return { maxDate: { value: control.value } };
      }
      return null;
    };
  }

  getInputTimeInSeconds(inputDate: Date): number {
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();
    const seconds = inputDate.getSeconds();

    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds;
  }

  timeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      const currentDate = new Date();
      this.minPickupDateTime = new Date(
        currentDate.getTime() + this.incomingSeconds * 1000
      );
      let parsedHours;
      let parsedMinutes;
      try {
        const [timePart, amPmPart] = control.value.split(/\s?(AM|PM)?\s?/i);
        const [hoursStr, minutesStr] = timePart.split(':');
        parsedHours = parseInt(hoursStr, 10);
        parsedMinutes = parseInt(minutesStr, 10);
        if (/^(0[1-9]|1[0-2])$/.test(amPmPart.toUpperCase())) {
          parsedHours += amPmPart === 'PM' ? 12 : -12;
        }
      } catch (e) {
        const [hoursStr, minutesStr] = control.value.split(':');
        parsedHours = parseInt(hoursStr, 10);
        parsedMinutes = parseInt(minutesStr, 10);
      }

      if (isNaN(parsedHours) || isNaN(parsedMinutes)) {
        return { invalidTimeFormat: true };
      }

      const totalSeconds = parsedHours * 3600 + parsedMinutes * 60;
      const minimumAllowedTimeInSeconds = this.getInputTimeInSeconds(
        this.minPickupDateTime
      );

      const inputDateString = this.form.get('pickup_date').getRawValue();
      if (inputDateString) {
        const inputDate = new Date(inputDateString);
        inputDate.setHours(0, 0, 0, 0);
        const modified = new Date(inputDate.getTime() + totalSeconds * 1000);
        if (modified > this.minPickupDateTime) {
          return null;
        }
      }

      if (totalSeconds < minimumAllowedTimeInSeconds) {
        const hours = this.secondsToHours(this.incomingSeconds);

        return {
          lessThanBaseTime: {
            value: control.value,
            message:
              // eslint-disable-next-line max-len
              `Please be informed there should be a difference of atleast ${hours}  hours between placing the order and the order collection time.`,
          },
        };
      }
      return null;
    };
  }

  guestSaveCheckboxClick() {
    this.analyticsService.trackUnified('save_guest_checkbox_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'save_guest_checkbox',
      component: 'autocheckout-form-component',
      service: 'dutyfree',
    });
  }

  secondsToHours(seconds: number) {
    const hours = seconds / 3600;
    return hours.toFixed(0);
  }

  async selectCountryCode() {
    const modal = await this.modalController.create({
      component: CountryCodeModalComponent,
    });
    modal.present();

    const { data } = await modal.onWillDismiss();
    this.selectedCountryCode = data || this.selectedCountryCode;
  }

  async openOptionListModal(item: any) {
    const modal = await this.modalController.create({
      component: SelectListModalComponent,
      componentProps: {
        title: item?.question || 'Select',
        options: item?.optionList || [],
      },
      initialBreakpoint: 0.8,
      breakpoints: [1],
      mode: 'ios',
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data) {
      this.form.get(item.name)?.setValue(data);
    }
  }

  async selectfromGuestList() {
    if (this.isGuestListModalOpen) {
      return;
    }
    this.isGuestListModalOpen = true;
    this.analyticsService.trackUnified('select_guest_list_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'select_guests_from_saved_list',
      component: 'autocheckout-form-component',
      service: 'dutyfree',
    });
    this.accountService
      .getUserGuestList()
      .pipe()
      .subscribe(async (response: any) => {
        if (!response || !response.userGuests) {
          this.analyticsService.trackResponseError(
            {
              message: 'Empty response received',
              statusCode: 204,
              apiName: 'getUserGuestList',
            },
            'Guest List - Empty Response'
          );
          return;
        }
        this.userGuestList = response.userGuests;
        const modal = await this.modalController.create({
          component: UserGuestListComponent,
          componentProps: {
            userGuestList: this.userGuestList,
          },
        });
        await modal.present();

        const { data } = await modal.onWillDismiss();
        this.isGuestListModalOpen = false;
        if (data) {          
          this.analyticsService.trackUnified('guest_selected_from_saved_list', {
            flow: 'shared',
            outcome: 'success',
            legacy_event_name: 'guest_selected_from_saved_list',
            component: 'autocheckout-form-component',
            service: 'dutyfree',
            userId: data?.userId,
            guestId: data?.id,
            firstName: data?.firstName,
            lastName: data?.lastName,
            type: data?.type,
            abbreviation: data?.abbreviation,
            passportIssuedCountry: data?.passportIssuedCountry,
            passportNo: data?.passportNo,
            dateOfBirth: data?.dob,
            nationality: data?.nationality,
            country: data?.country,
          });

          this.selectedCountryCode =
            countryMeta.find(
              (country) => country.dialCode === data['callingCode']
            ) || this.selectedCountryCode;
          console.log('Selected guest:', data);
          Object.entries(this.form.controls).forEach(([key, control]) => {
            let camelKey =
              key.charAt(0).toLowerCase() +
              key
                .slice(1)
                .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
            camelKey === 'last' ? (camelKey = 'lastName') : camelKey;
            const mappedKey =
              camelKey === 'phoneNumber' || camelKey === 'mobileNumber'
                ? 'phoneNo'
                : camelKey;
            control.patchValue(data[mappedKey]);

            if (camelKey === 'passportNumber') {
              control.patchValue(data['passportNo']);
            } else if (camelKey === 'passportExpiry') {
              control.patchValue(
                data['passportExpiryDate']
                  ? new Date(data['passportExpiryDate'])
                      .toISOString()
                      .substring(0, 10)
                  : null
              );
            } else if (camelKey === 'dateOfBirth') {
              control.patchValue(
                data['dob']
                  ? new Date(data['dob']).toISOString().substring(0, 10)
                  : null
              );
            } else if (camelKey === 'nationality') {
              control.patchValue(data['nationality']);
            } else if (camelKey === 'country') {
              control.patchValue(data['country']);
            }
          });
        }
      }, (error) => {
        this.isGuestListModalOpen = false;
      });
  }
}
